export default __webpack_public_path__ + "6558247cb94fe4cad601ae82cce0bc25.png";